<template>
    <div class="flex flex-col">
        <component
            v-for="(field, index) in fieldData"
            :key="index"
            :is="getComponent(field.type)"
            v-bind="field.props"></component>
    </div>
</template>

<script setup>
    import { ComponentType } from '@/enums/ComponentTypes';

    // Import custom components
    import HeaderIntro from '@/components/shared/components/HeaderIntro.vue';
    import LocationBlock from '@/components/shared/components/LocationBlock.vue';
    import Date from '@/components/date/DatePicker.vue';
    import Time from '@/components/time/TimePicker.vue';
    import ActionableButton from '@/components/shared/components/ActionableButton.vue';
    import SubmitButton from '@/components/form/SubmitButton.vue';
    import Navigator from '@/components/shared/components/Navigator.vue';
    import RichText from '@/components/shared/typography/RichText.vue';
    import Input from '@/components/form/Input.vue';
    import MobileInput from '@/components/form/MobileInput.vue';
    import Dropdown from '@/components/form/Dropdown.vue';
    import SpecialRequests from '@/components/form/SpecialRequests.vue';
    import MarketingPreferences from '@/components/form/MarketingPreferences.vue';
    import SideInfo from '@/components/book/SideInfo.vue';
    import Loader from '@/components/shared/components/Loader.vue';
    import Confirmation from '@/components/confirmation/Confirmation.vue';
    import Whatsapp from '@/components/book/Whatsapp';
    import DateTime from '@/components/date-time/DateTime.vue';
    import ErrorBanner from '@/components/shared/components/ErrorBanner.vue';

    const props = defineProps({
        fieldData: {
            type: Array,
            required: true,
        },
    });
    function getComponent(type) {
        // Define a mapping of custom components
        const componentMapping = {
            [ComponentType.HeaderIntro]: HeaderIntro,
            [ComponentType.Date]: Date,
            [ComponentType.Time]: Time,
            [ComponentType.LocationBlock]: LocationBlock,
            [ComponentType.ActionableButton]: ActionableButton,
            [ComponentType.SubmitButton]: SubmitButton,
            [ComponentType.Navigator]: Navigator,
            [ComponentType.RichText]: RichText,
            [ComponentType.Input]: Input,
            [ComponentType.MobileInput]: MobileInput,
            [ComponentType.Dropdown]: Dropdown,
            [ComponentType.SpecialRequests]: SpecialRequests,
            [ComponentType.MarketingPreferences]: MarketingPreferences,
            [ComponentType.SideInfo]: SideInfo,
            [ComponentType.Loader]: Loader,
            [ComponentType.Confirmation]: Confirmation,
            [ComponentType.Whatsapp]: Whatsapp,
            [ComponentType.DateTime]: DateTime,
            [ComponentType.ErrorBanner]: ErrorBanner,
        };

        // Check if the type has a custom component mapping, or use the type itself
        return componentMapping[type] || type;
    }
</script>
